import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#b1b1b1",
      "fill-rule": "evenodd",
      d: "M6 4V0H4v4H0v2h4v4h2V6h4V4z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }